import { getRoundedNumber } from "./roundedNumberHelper";

export function formatFileName(fileName?: string, fallback = "selfie.jpg") {
  if (!fileName) return fallback;
  return fileName.replace(" ", "_");
}

export function currencyFormatter(value: number) {
  // Redondear hacia abajo a 2 decimales usando el helper
  const roundedValue = parseFloat(getRoundedNumber(value));
  
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(roundedValue);
}

interface DateFormatterOptions {
  time?: boolean;
}
export function dateFormatter(date: string, options?: DateFormatterOptions) {
  const { time = false } = options || {};

  return new Date(date).toLocaleDateString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    ...(time && {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }),
  });
}

export function formatOptionalAmount(
  value: number | null | undefined,
  format: (n: number) => string
): string {
  if (value == null) return "-";
  return format(value);
}
